// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 163 ? "37e0aedc" : chunkId) + "." + {"3":"abce56c44e85a1db","163":"d2d363f1b2dc312c","436":"977a490aec6bb2e6","842":"8c76f9605849cc81"}[chunkId] + ".js";
};